import React from 'react'
import './CSS/OfflineOrders.css'
const OfflineOrders = () => {
  return (
    <div>
        Offline Orders
    </div>
  )
}

export default OfflineOrders
